import React, { Fragment, useState } from 'react';

import { Row, Col } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory  } from 'react-router-dom';

import mountainTop1 from '../../assets/images/mountainTop1.png';
import { Button } from 'reactstrap';

import { DiscordLoginButton } from "react-social-login-buttons";
import BeamMPLoginButton from '../../components/BeamMPLoginButton'

import * as api from '../../resources/api-constants.js'
import * as user from '../../resources/auth-service'

const LoginPage = () => {
  const history = useHistory();

  const forumSubmitButton = React.createRef();
  const [isActive, setActive] = useState(false)
  const [authMode, setAuthMode] = useState("choice")
  const [username, setUsername] = useState("username")
  const [password, setPassword] = useState("password")

  const changeAuthMode = () => {
    setAuthMode(authMode === "signin" ? "choice" : "signin")
  }

  const discordLogin = () => {
    // Redirect to /login-discord
    console.log(`${api.getURL()}/login-discord`)
    window.location.href =`${api.getURL()}/login-discord`
    return null
  }

  const forumLogin = (e) => {
    e.preventDefault();
    // @ts-ignore: Object is possibly 'null'.
    setActive(!isActive)
    // Post to /login-forum | username, password
    // Then redirect to provided location | NOW we will use JWT or something
    api.login_forum(username, password, (res) => {
      // @ts-ignore: Object is possibly 'null'.
      setActive(!isActive)
      if (res.status == 200) {
        user.setUser(res.user)
        return history.push(res.redirect)
      }
    })
  }
  
  return (
    <Fragment>
      <div className="hero-wrapper bg-composed-wrapper bg-midnight-bloom min-vh-100">
        <div className="flex-grow-1 w-100 d-flex align-items-center">
          <div
            className="bg-composed-wrapper--image opacity-6"
            style={{ backgroundImage: 'url(' + mountainTop1 + ')' }}
          />
          <div className="bg-composed-wrapper--bg bg-skim-blue opacity-2" />
          <div className="bg-composed-wrapper--content pt-5 pb-2 py-lg-5">
            <div className="container pb-5">
              <Row>
                <Col lg="10" className="px-0 mx-auto d-flex align-items-center">
                  <div className="text-center">
                    <div className="px-4 px-sm-0 text-white mt-4">
                      <h1 className="display-2 mb-5 font-weight-bold">
                        BeamMP Keymaster
                      </h1>
                      { (authMode == 'signin') &&
                        <form className="Auth-form">
                          <div className="Auth-form-content">
                            <h3 className="Auth-form-title">Sign In</h3>
                            <div className="text-center">
                              Not registered yet? <a href="https://forum.beammp.com/signup">Sign Up</a>
                            </div>
                            <div className="form-group mt-3">
                              <label>Username / Email</label>
                              <input
                                type="test"
                                name="username"
                                className="form-control mt-1"
                                placeholder="Username or Email Address"
                                onChange={e => setUsername(e.target.value)}
                              />
                            </div>
                            <div className="form-group mt-3">
                              <label>Password</label>
                              <input
                                type="password"
                                name="password"
                                className="form-control mt-1"
                                placeholder="Enter password"
                                onChange={e => setPassword(e.target.value)}
                              />
                            </div>
                            <div className="d-grid gap-2 mt-3">
                            <Button
                                size="lg"
                                color="success"
                                className={`d-block d-sm-inline-block mr-3`}
                                onClick={changeAuthMode}
                                title="Back to SignIn Options">
                                <span className="btn-wrapper--label">Back</span>
                                <span className="btn-wrapper--icon">
                                  <FontAwesomeIcon icon={['fas', 'arrow-left']} />
                                </span>
                              </Button>
                              <Button
                                size="lg"
                                color="success"
                                className={`d-block d-sm-inline-block ${isActive ? "disabled" : ""}`}
                                onClick={forumLogin}
                                ref={forumSubmitButton}
                                title="Sign In using BeamMP Forum Account">
                                <span className="btn-wrapper--label">{isActive ? 'Loading' : "Login"}</span>
                                <span className="btn-wrapper--icon">
                                  <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                </span>
                              </Button>
                            </div>
                            <p className="text-center mt-2">
                              Forgot <a href="https://forum.beammp.com/login">password?</a>
                            </p>
                          </div>
                        </form>
                      }
                      { (authMode == 'choice') &&
                        <div className="Auth-form-container">
                          <form className="Auth-form">
                            <div className="Auth-form-content">
                              <h3 className="Auth-form-title">Sign In</h3>
                              <div className="text-center">
                                to{" "}
                                BeamMP Keymaster
                              </div>
                              <div className="d-grid gap-2 mt-3">
                                <DiscordLoginButton onClick={discordLogin} />
                              </div>
                              { process.env.NODE_ENV == "development" && 
                              <>
                                <div className="d-grid gap-2 mt-3">
                                  <BeamMPLoginButton onClick={changeAuthMode} />
                                </div>
                                <p className="text-center mt-2">
                                  Not registered yet? <a href="https://forum.beammp.com/signup">Sign Up</a>
                                </p>
                              </>
                              }
                            </div>
                          </form>
                        </div>
                      }
                      <div className="divider border-2 border-light my-5 border-light opacity-2 mx-auto rounded-circle w-50" />
                      <small className="d-block pt-2">
                        Discord is a third party service. For privacy concerns please see their privacy policy.
                      </small>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginPage;
